var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.view)?_c(_vm.view,{tag:"component",attrs:{"hotel":_vm.hotel}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }